import React from 'react';

const LoadingPage = () => (
  <div className="absolute inset-0 z-50 bg-sand-lighter dark:bg-gray-161616 flex justify-center items-center">
    <div className="relative splash-loader w-32 h-32">
      <img src="/img/dash.png" alt="Loading..." className="mt-1" />
    </div>
  </div>
);

export default LoadingPage;
